import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link } from "./NotificationItemNFTLink.styled";
const NotificationItemNFTLink = React.memo((props) => {
    const { link, rarity, name } = props;
    return (_jsx(Link, { href: link, rarity: rarity, children: name }));
});
export { NotificationItemNFTLink };
//# sourceMappingURL=NotificationItemNFTLink.js.map